import {
  Box,
  Text,
  Flex,
  Spacer,
  HStack,
  useTheme,
  Center,
  Spinner,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import CourseTextButton from "../../../components/buttons/CoursesTextButton";
import SearchBox from "../../../components/searchbox/SearchBox";
import NumberInputLimit from "../../../components/numberInput/NumberInputLimit";
import CustomTable from "../../../components/table/customTable/CustomTable";
import { useDisclosure } from "@chakra-ui/react";
import AddSubjectModal from "../../../components/modals/AddModals/AddSubjectModal";
import { useDispatch, useSelector } from "react-redux";
import { getAllSubjects } from "../../../store/slice/subjectSlice";
const Subject = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { subjects, status } = useSelector((state) => state.subject);
  const { primaryBlue } = theme.colors.pallete;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [editData, setEditData] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [limit, setLimit] = useState(5);

  useEffect(() => {
    dispatch(getAllSubjects());
  }, [dispatch]);

  const handleAddSubject = () => {
    setEditData(null);
    onOpen();
  };

  const handleEditSubject = (id) => {
    const selectedSubject = subjects.find((subject) => subject.id === id);
    if (selectedSubject) {
      setEditData(selectedSubject);
      onOpen();
    }
  };

  const filteredSubject = subjects?.filter((course) =>
    course?.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Box w={"100%"}>
      <Flex>
        <Text fontWeight={500} fontSize={"18px"} color={primaryBlue}>
          Subject
        </Text>
        <Spacer />
        <CourseTextButton text={"Add Subject"} onClick={handleAddSubject} />
      </Flex>
      <Flex mt={"2%"}>
        <HStack spacing={4}>
          <Text fontSize={"14px"}>Show :</Text>
          <NumberInputLimit value={limit} onChange={setLimit} />
        </HStack>

        <Spacer />

        <SearchBox onSearch={setSearchTerm} />
      </Flex>
      <Box>
        {status === "loading" ? (
          <Box
            height="100vh"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Spinner size="md" color="blue.500" />
          </Box>
        ) : (
          <CustomTable
            data={filteredSubject}
            entityType="subject"
            onEdit={handleEditSubject}
            limit={limit}
          />
        )}
      </Box>

      <AddSubjectModal isOpen={isOpen} onClose={onClose} editData={editData} />
    </Box>
  );
};

export default Subject;
